export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'geslacht':
            case 'state':
                translation = '%s ble ikke valgt';
                break;

            case 'voorletter':
            case 'achternaam':
                translation = '%s kan ikke være tomt';
                break;

            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s er et obligatorisk felt';
                break;

            case 'email':
            case 'heeltelefoonnummer':
            case 'mobiel':
            case 'zipcode':
            case 'geboortedatum':
            case 'rekeningnummer':
                translation = '%s ble ikke fylt ut riktig';
                break;

            case 'opt-in':
                translation = 'Merk av i boksen for å fortsette';
                break;

            default:
                translation = 'Dette feltet ble ikke fylt ut riktig';
                break;
        }

        return translation;
    }

    /**
     * @link https://developers.google.com/maps/documentation/geocoding/intro?hl=nl#StatusCodes
     */
    addressMap(textType) {
        let translation = '';

        switch (textType) {
            case 'ZERO_RESULTS':
                translation = 'Ingen resultater';
                break;

            case 'address-not-checked':
                translation = 'Dra kartet og slipp nålen på taket av huset ditt';
                break;

            default:
                translation = 'Det har oppstått en feil';
                break;
        }

        return translation;
    }
}
